/**
 * Функция для кропа изображения на основе выбранной области
 * @param {string} imageSrc - URL или Data URL изображения
 * @param {Object} pixelCrop - Объект с параметрами кропа в пикселях
 * @param {number} pixelCrop.x - X-координата верхнего левого угла кропа
 * @param {number} pixelCrop.y - Y-координата верхнего левого угла кропа
 * @param {number} pixelCrop.width - Ширина области кропа
 * @param {number} pixelCrop.height - Высота области кропа
 * @returns {Promise<File>} - Promise, который разрешается в объект File с кропнутым изображением
 */
export const cropImage = async (imageSrc, pixelCrop) => {
  // Проверка входных данных
  if (!imageSrc) {
    console.error('Ошибка: imageSrc не определен');
    throw new Error('Image source is undefined');
  }
  
  if (!pixelCrop || !pixelCrop.width || !pixelCrop.height) {
    console.error('Ошибка: некорректные параметры кропа', pixelCrop);
    throw new Error('Invalid crop parameters');
  }

  try {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      throw new Error('Canvas context is not available');
    }

    // Проверка, что изображение загружено корректно
    if (image.width === 0 || image.height === 0) {
      console.error('Ошибка: изображение имеет нулевые размеры');
      throw new Error('Image has zero dimensions');
    }

    // Устанавливаем размеры canvas равными размерам области кропа
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    // Рисуем кропнутое изображение на canvas
    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height,
    );

    // Преобразуем canvas в Blob
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error('Ошибка: canvas пустой или не удалось создать blob');
            reject(new Error('Canvas is empty'));
            return;
          }

          // Создаем File из Blob
          const file = new File([blob], 'cropped-image.jpg', {
            type: 'image/jpeg',
            lastModified: new Date().getTime(),
          });

          resolve(file);
        },
        'image/jpeg',
        0.95,
      ); // качество JPEG 95%
    });
  } catch (error) {
    console.error('Ошибка при кропе изображения:', error);
    throw error;
  }
};

/**
 * Вспомогательная функция для создания объекта Image из URL
 * @param {string} url - URL или Data URL изображения
 * @returns {Promise<HTMLImageElement>} - Promise, который разрешается в объект Image
 */
const createImage = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.src = url;
  });
};
